import React from 'react'
import { IconProps } from '../types'

export default function WavesDecorativeIcon({
    className = '',
    color = 'black',
    ...props
}: IconProps) {
    return (
        <svg
            viewBox="0 0 263 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`w-full h-auto ${className}`}
            {...props}
        >
            <path
                d="M1 12.76C34.2289 6.61173 132.833 -3.84033 261.418 3.5376"
                stroke={color}
                strokeOpacity="0.06"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M52.5234 25.6383C76.7484 21.2467 148.634 13.7809 242.376 19.0509"
                stroke={color}
                strokeOpacity="0.06"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14.4453 43.0008C46.0306 37.1453 139.757 27.1909 261.982 34.2175"
                stroke={color}
                strokeOpacity="0.06"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}
